import React from 'react';

import Responsive from '@/components/Responsive';

import FilterHeaderDesktop from './index.desktop';
import FilterHeaderMobile from './index.mobile';
import { FilterHeaderProps } from './types';

function FilterHeader(props: FilterHeaderProps) {
  return (
    <Responsive>
      <Responsive.Default>
        <FilterHeaderDesktop {...props} />
      </Responsive.Default>
      <Responsive.Mobile>
        <FilterHeaderMobile {...props} />
      </Responsive.Mobile>
    </Responsive>
  );
}

export default FilterHeader;
